






































































































































































import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
import Loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";
// api
import {
  memberList,
  updateVerifyStatus,
  memberUpdate,
  updateShopImage,
} from "@/api/vip";
import { selectAllLabel } from "@/api/discount";
import { MemberInfo } from "@/types/api/vip";
import { CreateDiscountTag } from "@/types/api/discount";
import copy from "@/utils/deepCopy";

@Component
export default class Table extends Mixins(Loading, tablePagination) {
  @Prop() fromDate!: string;
  @Prop() shopName!: string;
  @Prop() phone!: string;
  @Prop() userName!: string;
  @Prop() enterCost!: number;

  private tableData: Array<any> = [];
  imgUrl: string = "";
  dialogTitle: string = "";
  dialogVisibleImg: boolean = false;
  index: number = 0;
  keyName: string = "";
  dialogVisibleIdentity: boolean = false; // 身份对话框
  identityOptions: Array<CreateDiscountTag> = []; // 身份类型数组
  form: { id: number; memberDiscountId: number | string | undefined } = {
    id: 0,
    memberDiscountId: "",
  };

  mounted() {
    this.getData();
  }

  /**
   * methods
   */
  getData(): void {
    this.showLoading();
    memberList({
      fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
      toDate: this.fromDate && this.fromDate.toString().split(",")[1],
      shopName: this.shopName,
      phone: this.phone,
      userName: this.userName,
      enterCost: this.enterCost,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
    }).then((res: any) => {
      this.tableData = res.data.list.filter((e: any) => e.status == 1);
      this.total = res.data.total;
      this.hideLoading();
    });
  }
  // 预览图片
  previewPic(url: string, title: string) {
    this.dialogTitle = title;
    this.imgUrl = url;
    this.dialogVisibleImg = true;
  }
  // 上传成功
  onSuccess(res: any, file: any) {
    updateShopImage({
      memberId: this.tableData[this.index].id,
      [this.keyName]: res.data.url,
    }).then((res: any) => {
      this.$message.success("上传成功");
      this.getData();
    });
    // this.tableData[this.index][this.keyName] =
    //   this.$uploadImgUrl + "/" + res.data.url;
  }
  // 图片上传之前限制
  beforeAvatarUpload(file: any, index: number, key: string) {
    this.index = index;
    this.keyName = key;
    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
      this.$message.error("上传头像图片大小不能超过 1MB!");
    }
    return isLt1M;
  }
  // 修改审核状态
  changeState(row: any, title: string) {
    let status: number = 0;
    let word: string = "";
    switch (row.memberEnter) {
      case 0:
        this.$message.error("用户未入驻，无法操作");
        return;
        break;
      case 1:
        word = `是否通过 ”${row.nickname || "id：" + row.id}“ 入驻申请 ?`;
        status = 2;
        break;
      case 2:
        word = `是否禁用账号 ”${row.nickname || "id：" + row.id}“`;
        status = 3;
        break;
      case 3:
        word = `是否解除账号 ”${row.nickname || "id：" + row.id}“`;
        status = 2;
        break;
      default:
        word = "预留状态，暂不支持操作";
        status = 1;
        break;
    }
    this.$confirm(word, `${title}`, {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      updateVerifyStatus({ id: row.id, status: status }).then((res: any) => {
        this.$message.success("修改成功");
        this.getData();
      });
    });
  }
  // 修改用户类型
  modifyMemberType(row: any) {
    this.form.id = row.id;
    this.form.memberDiscountId = row.memberDiscountId;
    selectAllLabel().then((res: any) => {
      this.identityOptions = res.data;
      this.dialogVisibleIdentity = true;
    });
  }
  // 确认身份
  confirmIdentity() {
    memberUpdate({
      id: this.form.id,
      memberDiscountId: this.form.memberDiscountId,
    }).then((res: any) => {
      this.$message.success("修改成功");
      this.getData();
    });
    this.dialogVisibleIdentity = false;
  }
}
